import {
  APP_BACKGROUND_COLOR,
  APP_COLOR,
  APP_HOVER_COLOR,
  BORDER_COLOR,
  FONT_FAMILY,
  TEXT_COLOR,
} from "../../theme";
export const batchTrackCollabDetailsStyles = {
  addButton: {
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  uploadingSpan: {
    marginLeft: 10,
    fontFamily: FONT_FAMILY,
    fontSize: "20px",
  } as const,
  inviteEmailContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
    marginBottom: 2,
  } as const,
  horizontalDiv: {
    width: "100%",
    height: 2,
    backgroundColor: "white",
    marginBottom: 10,
  } as const,
  addCreatorsContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
  } as const,
  helpOutlineIcon: {
    height: 16,
    width: 16
  } as const,
  collaboratorsBox: {
    margin: "20px 0 40px"
  } as const,
  userNameTextField: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: TEXT_COLOR,
  } as const,
  collaboratorUserName: {
    fontFamily: FONT_FAMILY,
    flexGrow: 1,
  } as const,
  deleteBox: {
    marginBottom: 10,
    width: "100%"
  } as const,
  buttonBox: {
    display: "flex",
    justifyContent: "flex-end"
  } as const,
};

export const batchTrackDetailsStyles = {
  artistInput: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: TEXT_COLOR,
    borderColor: BORDER_COLOR,
  } as const,
  albumInput: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: TEXT_COLOR,
    borderColor: BORDER_COLOR,
  } as const,
  genreLabel: {
    fontSize: 16,
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
    color: TEXT_COLOR,
  } as const,
};
